import { useDispatch, useSelector } from 'react-redux';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;

// Custom hooks for specific slices
export const useAuth = () => {
  const dispatch = useAppDispatch();
  const auth = useAppSelector((state) => state.auth);
  return { ...auth, dispatch };
};

export const usePartner = () => {
  const dispatch = useAppDispatch();
  const partner = useAppSelector((state) => state.partner);
  return { ...partner, dispatch };
};

export const useMothers = () => {
  const dispatch = useAppDispatch();
  const mothers = useAppSelector((state) => state.mothers);
  return { ...mothers, dispatch };
};

export const useSubscription = () => {
  const dispatch = useAppDispatch();
  const subscription = useAppSelector((state) => state.subscription);
  return { ...subscription, dispatch };
};

export const useMatchFunding = () => {
  const dispatch = useAppDispatch();
  const matchFunding = useAppSelector((state) => state.matchFunding);
  return { ...matchFunding, dispatch };
};

export const useContributions = () => {
  const dispatch = useAppDispatch();
  const contributions = useAppSelector((state) => state.contributions);
  return { ...contributions, dispatch };
};

export const useActivities = () => {
  const dispatch = useAppDispatch();
  const activities = useAppSelector((state) => state.activities);
  return { ...activities, dispatch };
};

export const useUI = () => {
  const dispatch = useAppDispatch();
  const ui = useAppSelector((state) => state.ui);
  return { ...ui, dispatch };
};

// Combined hooks for common use cases
export const usePartnerDashboard = () => {
  const dispatch = useAppDispatch();
  const partner = useAppSelector((state) => state.partner);
  const mothers = useAppSelector((state) => state.mothers);
  const subscription = useAppSelector((state) => state.subscription);
  const ui = useAppSelector((state) => state.ui);
  
  return {
    partner,
    mothers,
    subscription,
    ui,
    dispatch,
  };
};

export const useAuthState = () => {
  const dispatch = useAppDispatch();
  const auth = useAppSelector((state) => state.auth);
  const ui = useAppSelector((state) => state.ui);
  
  return {
    auth,
    ui,
    dispatch,
  };
};
